import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import RelatedPosts from '../../components/feature/RelatedPosts';
import FAQSection from '../../components/feature/FAQSection';
import { articles } from '../../mocks/articles';

const Iwin68Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const article = {
    id: 31,
    title: 'Hướng Dẫn Nạp Tiền Iwin68 Nhanh – Bảo Mật – Không Lỗi 2025',
    slug: 'huong-dan-nap-tien-iwin68-nhanh-bao-mat-khong-loi-2025',
    excerpt: 'Trong thế giới cá cược trực tuyến, yếu tố nhanh – chuẩn – an toàn luôn là kim chỉ nam của mọi giao dịch.',
    image: 'https://public.readdy.ai/ai/img_res/508fb68f57fe570a7c9b95f4a60c7be3.jpg',
    category: 'Tin Game',
    game: 'Tin Game',
    author: {
      name: 'Minh Tuấn',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20vietnamese%20tech%20writer%20portrait%2C%20male%2C%20friendly%20smile%2C%20modern%20office%20background%2C%20professional%20headshot&width=200&height=200&seq=author-minhtuan&orientation=squarish',
      role: 'Chuyên gia Công nghệ'
    },
    date: '2025-01-16',
    readTime: '8 phút đọc',
    views: '2.5M'
  };

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.excerpt,
    "image": article.image,
    "datePublished": article.date,
    "dateModified": article.date,
    "author": {
      "@type": "Person",
      "name": article.author.name
    },
    "publisher": {
      "@type": "Organization",
      "name": "GameTV.asia",
      "logo": {
        "@type": "ImageObject",
        "url": "https://gametv.asia/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://gametv.asia/bai-viet/${article.slug}`
    }
  };

  const breadcrumbItems = [
    { label: 'Trang chủ', path: '/' },
    { label: 'Tin Game', path: '/tin-game' },
    { label: article.title }
  ];

  const faqs = [
    {
      question: 'Nạp tiền iwin68 có an toàn không?',
      answer: 'Hệ thống nạp tiền iwin68 được mã hóa bằng công nghệ SSL và tường lửa đa lớp, đảm bảo mọi dữ liệu cá nhân và giao dịch ngân hàng đều được bảo vệ nghiêm ngặt. Người chơi có thể hoàn toàn yên tâm về tính bảo mật.'
    },
    {
      question: 'Mất bao lâu để tiền vào tài khoản iwin68?',
      answer: 'Hệ thống nạp tiền iwin68 xử lý tự động và cộng tiền vào tài khoản trong vòng 3-5 phút. Với công nghệ xử lý siêu tốc, người chơi có thể bắt đầu tham gia game ngay lập tức.'
    },
    {
      question: 'Có những phương thức nạp tiền nào tại iwin68?',
      answer: 'Iwin68 hỗ trợ đa dạng phương thức thanh toán bao gồm chuyển khoản ngân hàng, ví điện tử (Momo, ZaloPay, ViettelPay) và thẻ cào điện thoại. Người chơi có thể lựa chọn phương thức phù hợp nhất với mình.'
    },
    {
      question: 'Nạp tiền iwin68 có được khuyến mãi không?',
      answer: 'Có, khi nạp tiền iwin68 người chơi có thể nhận thêm 10-30% giá trị khuyến mãi cho giao dịch đầu tiên trong ngày. Ngoài ra còn có các sự kiện hoàn tiền, tích điểm và vòng quay may mắn cho thành viên nạp đều.'
    },
    {
      question: 'Làm gì khi nạp tiền iwin68 bị lỗi?',
      answer: 'Nếu gặp sự cố khi nạp tiền iwin68, hãy giữ lại biên lai hoặc chụp màn hình giao dịch và liên hệ ngay bộ phận hỗ trợ 24/7. Đội ngũ sẽ xử lý và hoàn tiền trong vòng vài phút.'
    }
  ];

  return (
    <div className="min-h-screen bg-dark-bg">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />

      <Header />

      <main>
        <div className="relative h-[40vh] sm:h-[50vh] lg:h-[60vh] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-dark-bg"></div>
        </div>

        <article className="max-w-4xl mx-auto px-4 sm:px-6 -mt-20 sm:-mt-28 lg:-mt-32 relative z-10">
          <Breadcrumb items={breadcrumbItems} />

          <header className="bg-dark-card/80 backdrop-blur-lg border border-gray-800 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
            <Link
              to="/tin-game"
              className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-gaming text-white text-xs sm:text-sm font-semibold rounded-full mb-3 sm:mb-4 hover:scale-105 transition-transform whitespace-nowrap"
            >
              {article.category}
            </Link>

            <h1 className="font-exo font-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white mb-4 sm:mb-6 leading-tight">
              {article.title}
            </h1>

            <div className="flex flex-wrap items-center gap-3 sm:gap-4 lg:gap-6 text-xs sm:text-sm text-gray-400 mb-4 sm:mb-6">
              <div className="flex items-center gap-2">
                <img
                  src={article.author.avatar}
                  alt={article.author.name}
                  className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 border-accent-cyan"
                />
                <div>
                  <div className="text-white font-semibold text-xs sm:text-sm">{article.author.name}</div>
                  <div className="text-[10px] sm:text-xs text-gray-500">{article.author.role}</div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                <time dateTime={article.date}>{article.date}</time>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                <span>{article.readTime}</span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                <span>{article.views} lượt xem</span>
              </div>
            </div>

            <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed border-l-4 border-accent-cyan pl-3 sm:pl-4">
              {article.excerpt}
            </p>
          </header>

          <div className="bg-dark-card/80 backdrop-blur-lg border border-gray-800 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
            <div className="prose prose-invert prose-sm sm:prose-base lg:prose-lg max-w-none">
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Trong thế giới cá cược trực tuyến, yếu tố nhanh – chuẩn – an toàn luôn là kim chỉ nam của mọi giao dịch. Với nền tảng uy tín <a href="https://fmc.uk.net/" target="_blank" rel="dofollow" className="text-[#0066CC] hover:text-[#0052A3] underline">iwin68</a>, nạp tiền iwin68 không chỉ là một thao tác nạp đơn thuần, mà còn là bước khởi đầu quan trọng giúp mọi người bắt nhịp với hàng ngàn tựa game, cược thể thao và event thưởng nóng mỗi ngày. Cùng chúng tôi tìm hiểu cách nạp tiền siêu tốc, không lỗi và bảo mật tuyệt đối tại iwin68 nhé.
              </p>

              <h2 className="font-exo font-bold text-xl sm:text-2xl lg:text-3xl text-white mt-8 sm:mt-12 mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
                Cách thực hiện nạp tiền iwin68 chi tiết từng bước
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Sau khi hiểu các hình thức thanh toán, mọi người cần nắm rõ quy trình nạp tiền iwin68 để tránh sai sót khi giao dịch. Dưới đây là hướng dẫn cụ thể từ A đến Z cho từng bước thực hiện.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Bước 1: Đăng nhập và chọn mục nạp tiền
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Người chơi truy cập vào website hoặc ứng dụng chính thức của iWin68, đăng nhập bằng tài khoản đã đăng ký. Tại giao diện chính, chọn mục "Nạp tiền". Giao diện nạp tiền iwin68 sẽ hiển thị danh sách các phương thức để mọi người lựa chọn phù hợp với mình. Việc chọn đúng kênh giao dịch sẽ giúp quá trình xử lý nhanh và chính xác hơn.
              </p>

              <div className="my-6 sm:my-8 rounded-lg sm:rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=mobile%20banking%20app%20login%20screen%2C%20secure%20authentication%2C%20modern%20interface%2C%20user-friendly%20design%2C%20professional%20lighting&width=800&height=500&seq=iwin68-step1&orientation=landscape"
                  alt="Đăng nhập và chọn mục nạp tiền"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Bước 2: Chọn phương thức thanh toán và nhập số tiền
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Khi đã vào phần giao dịch, người chơi chọn kênh thanh toán mong muốn như ngân hàng, ví điện tử hoặc thẻ cào. Sau đó nhập số tiền cần nạp – lưu ý nhập chính xác vì hệ thống nạp tiền iwin68 xử lý tự động, nếu sai lệch có thể khiến giao dịch bị treo. Trước khi xác nhận, kiểm tra kỹ thông tin người nhận để đảm bảo khớp với tài khoản chính thức của iWin68.
              </p>

              <div className="my-6 sm:my-8 rounded-lg sm:rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=payment%20method%20selection%20screen%2C%20multiple%20payment%20options%2C%20digital%20wallet%20icons%2C%20bank%20transfer%2C%20modern%20fintech%20interface&width=800&height=500&seq=iwin68-step2&orientation=landscape"
                  alt="Chọn phương thức thanh toán"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Bước 3: Xác nhận giao dịch và kiểm tra số dư
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Sau khi hoàn tất thao tác chuyển khoản hoặc thanh toán, quay lại giao diện iWin68 để bấm "Xác nhận". Hệ thống sẽ xử lý và cộng tiền vào tài khoản trong vòng 3–5 phút. Để đảm bảo chắc chắn, người chơi có thể kiểm tra mục lịch sử nạp tiền iwin68. Nếu gặp sự cố, hãy liên hệ ngay bộ phận hỗ trợ 24/7 để được xử lý trong vòng vài phút.
              </p>

              <div className="my-6 sm:my-8 rounded-lg sm:rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=transaction%20confirmation%20screen%2C%20successful%20payment%20notification%2C%20account%20balance%20display%2C%20secure%20system%2C%20modern%20design&width=800&height=500&seq=iwin68-step3&orientation=landscape"
                  alt="Bảo mật hệ thống nạp tiền iwin68"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>

              <h2 className="font-exo font-bold text-xl sm:text-2xl lg:text-3xl text-white mt-8 sm:mt-12 mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
                Lưu ý quan trọng khi nạp tiền iwin68 để tránh lỗi mất tiền
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Ngoài việc thao tác đúng, người chơi cần nắm thêm một số lưu ý quan trọng giúp việc nạp tiền iwin68 luôn an toàn, mượt mà và không xảy ra sai sót trong quá trình giao dịch.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Kiểm tra kỹ thông tin tài khoản nhận tiền
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Một trong những lỗi phổ biến nhất khi nạp tiền iwin68 là chuyển sai tài khoản. Vì vậy, cược thủ cần kiểm tra kỹ tên ngân hàng, số tài khoản và nội dung chuyển khoản được hiển thị. Tuyệt đối không chuyển tiền theo thông tin từ bên thứ ba hay nhóm cộng đồng. Mọi giao dịch chỉ thực hiện theo dữ liệu hiển thị trực tiếp trong ứng dụng iWin68.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Không thực hiện giao dịch khi hệ thống bảo trì
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Trong quá trình nâng cấp, hệ thống nạp tiền iwin68 có thể tạm ngưng để bảo trì. Nếu người chơi cố nạp lúc này, tiền có thể bị treo hoặc chậm xử lý. Vì vậy, hãy kiểm tra thông báo từ iWin68 trước khi giao dịch. Khi thấy banner "Đang bảo trì hệ thống nạp", tốt nhất nên đợi 15–20 phút rồi thử lại.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Giữ lại biên lai và chụp màn hình giao dịch
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Một thói quen nhỏ nhưng rất quan trọng khi nạp tiền iwin68 là lưu lại ảnh chụp biên lai hoặc màn hình xác nhận. Trong trường hợp phát sinh lỗi, đây sẽ là bằng chứng giúp đội ngũ hỗ trợ dễ dàng kiểm tra và hoàn tiền nhanh chóng. Cược thủ nên lưu trữ ảnh này ít nhất 24 giờ sau khi giao dịch hoàn tất.
              </p>

              <div className="my-6 sm:my-8 rounded-lg sm:rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=promotional%20banner%2C%20special%20offers%2C%20bonus%20rewards%2C%20attractive%20design%2C%20gaming%20platform%20promotions%2C%20vibrant%20colors&width=800&height=500&seq=iwin68-promo&orientation=landscape"
                  alt="Khuyến mãi iwin68 mới nhất"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>

              <h2 className="font-exo font-bold text-xl sm:text-2xl lg:text-3xl text-white mt-8 sm:mt-12 mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
                Lợi ích khi nạp tiền iwin68 tại hệ thống chính thức
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Ngoài yếu tố tiện lợi, hệ thống nạp tiền iwin68 còn mang đến nhiều giá trị vượt trội cho người chơi. Cùng chúng tôi điểm qua những lợi ích mà không phải nền tảng nào cũng có được.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Giao dịch tự động và xử lý siêu tốc
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Tốc độ luôn là yếu tố hàng đầu. Khi nạp tiền iwin68, toàn bộ quy trình đều được hệ thống xử lý tự động, không cần chờ nhân viên xác nhận thủ công. Trong vòng vài giây, tiền sẽ vào ví để người chơi sẵn sàng tham gia game hoặc đặt cược. Đây là điểm cộng lớn giúp iWin68 giữ vững danh hiệu nền tảng có tốc độ xử lý nhanh nhất hiện nay.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Bảo mật tuyệt đối thông tin người chơi
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Hệ thống nạp tiền iwin68 được mã hóa bằng công nghệ SSL và tường lửa đa lớp, đảm bảo mọi dữ liệu cá nhân, giao dịch ngân hàng và ví điện tử đều được bảo vệ nghiêm ngặt. Người chơi có thể hoàn toàn yên tâm rằng mọi thông tin sẽ không bao giờ bị rò rỉ ra bên ngoài.
              </p>

              <h3 className="font-exo font-bold text-lg sm:text-xl lg:text-2xl text-white mt-6 sm:mt-8 mb-3 sm:mb-4">
                Khuyến mãi nạp tiền cực khủng
              </h3>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Một điểm mà mọi người luôn yêu thích khi nạp tiền iwin68 là chính sách thưởng nạp cực kỳ hấp dẫn. Chỉ cần thực hiện giao dịch đầu tiên trong ngày, người chơi có thể nhận thêm 10–30% giá trị khuyến mãi. Ngoài ra còn có các sự kiện hoàn tiền, tích điểm và vòng quay may mắn cho thành viên nạp đều mỗi tuần.
              </p>

              <div className="my-6 sm:my-8 rounded-lg sm:rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=customer%20support%20service%2C%2024%2F7%20help%20desk%2C%20technical%20assistance%2C%20professional%20support%20team%2C%20modern%20call%20center&width=800&height=500&seq=iwin68-support&orientation=landscape"
                  alt="Xử lý lỗi iwin68 nhanh"
                  className="w-full h-auto"
                  loading="lazy"
                />
              </div>

              <h2 className="font-exo font-bold text-xl sm:text-2xl lg:text-3xl text-white mt-8 sm:mt-12 mb-4 sm:mb-6 flex items-center gap-2 sm:gap-3">
                <div className="w-1 h-6 sm:h-8 bg-gradient-gaming"></div>
                Lời kết
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Việc <a href="https://fmc.uk.net/nap-tien-iwin68/" target="_blank" rel="dofollow" className="text-[#0066CC] hover:text-[#0052A3] underline">nạp tiền iwin68</a> không chỉ là thao tác kỹ thuật mà còn thể hiện mức độ uy tín và chuyên nghiệp của nền tảng. Với hệ thống bảo mật tối ưu, tốc độ xử lý siêu nhanh cùng hàng loạt khuyến mãi hấp dẫn, iWin68 đã trở thành lựa chọn hàng đầu của cộng đồng cược thủ.
              </p>
            </div>

            <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-800">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-gray-400 font-semibold text-xs sm:text-sm">Tags:</span>
                {['iwin68', 'nạp tiền', 'hướng dẫn', 'game online', 'thanh toán'].map((tag, index) => (
                  <Link
                    key={index}
                    to={`/tag/${tag.toLowerCase().replace(/\s+/g, '-')}`}
                    className="px-2 sm:px-3 py-1 bg-gray-800 text-gray-300 text-xs sm:text-sm rounded-full hover:bg-accent-cyan hover:text-white transition-colors whitespace-nowrap"
                  >
                    #{tag}
                  </Link>
                ))}
              </div>
            </div>

            <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-800">
              <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
                <span className="text-gray-400 font-semibold text-xs sm:text-sm">Chia sẻ:</span>
                <button className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-blue-600 text-white rounded-full hover:scale-110 transition-transform">
                  <i className="ri-facebook-fill text-sm sm:text-base"></i>
                </button>
                <button className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-sky-500 text-white rounded-full hover:scale-110 transition-transform">
                  <i className="ri-twitter-fill text-sm sm:text-base"></i>
                </button>
                <button className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-red-600 text-white rounded-full hover:scale-110 transition-transform">
                  <i className="ri-youtube-fill text-sm sm:text-base"></i>
                </button>
                <button className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-gray-700 text-white rounded-full hover:scale-110 transition-transform">
                  <i className="ri-link text-sm sm:text-base"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="bg-dark-card/80 backdrop-blur-lg border border-gray-800 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-6">
              <img
                src={article.author.avatar}
                alt={article.author.name}
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-full border-4 border-accent-cyan"
              />
              <div className="flex-1">
                <h3 className="font-exo font-bold text-xl sm:text-2xl text-white mb-2">
                  {article.author.name}
                </h3>
                <p className="text-accent-cyan text-xs sm:text-sm mb-2 sm:mb-3">{article.author.role}</p>
                <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
                  Chuyên gia công nghệ với hơn 7 năm kinh nghiệm trong lĩnh vực thanh toán trực tuyến và bảo mật. Đam mê chia sẻ kiến thức về các nền tảng game và cá cược uy tín tại Việt Nam.
                </p>
              </div>
            </div>
          </div>
        </article>

        <FAQSection faqs={faqs} />

        <RelatedPosts posts={articles} currentPostId={article.id} />
      </main>

      <Footer />
    </div>
  );
};

export default Iwin68Page;